module.exports = __webpack_public_path__ + "static/the-gene-5f4e583f38de76b8b4ff157f858e70e8.jpg";